import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectUser } from '../../../types/ProjectUser';
import { Peer, Peers } from '../../../types/SignalR';
import ProjectUserElement from '../../ProjectUserElement/ProjectUserElement';

import './MainSectionProjectUsers.scss';
import { CaptionModeEnum } from '../../../types/enums/CaptionModeEnum';
import { UserTypeEnum } from '../../../types/enums/UserTypesEnum';
import useProject from '../../../hooks/useProject';

type MainSectionProjectUsersProp = {
  isUserActiveCallback: (userId: string) => boolean;
  isUserLiveCallback: (userId: string) => boolean;
  connectedPeers: Peers;
};

const MainSectionProjectUsers = (props: MainSectionProjectUsersProp) => {
  const { t } = useTranslation();
  const { project } = useProject();

  return (
    <div className="main-section-project-users">
      <ProjectUserElement
        colorId={0}
        userId={project?.createdByUser?.id ?? ''}
        isUserActiveCallback={props.isUserActiveCallback}
        isUserLiveCallback={props.isUserLiveCallback}
        name={project?.createdByUser?.name ?? ''}
        description={t('labels.producer-description')}
      />
      {project?.projectUsers &&
        project?.projectUsers.length > 0 &&
        project?.projectUsers.map((projectUser: ProjectUser, index: number) => (
          <div key={projectUser?.id}>
            {(project?.encoder?.captionMode !== CaptionModeEnum.None &&
            projectUser?.userType === UserTypeEnum.Captioner) || (projectUser?.userType === UserTypeEnum.Connector) ? (
              <ProjectUserElement
                colorId={index + 1}
                name={projectUser.name}
                userId={projectUser.id}
                isUserActiveCallback={props.isUserActiveCallback}
                isUserLiveCallback={props.isUserLiveCallback}
                description={projectUser?.userType === UserTypeEnum.Captioner ? 'Captioner' : 'Connector'}
              />
            ) : null}
          </div>
        ))}
      {props.connectedPeers.map((peer: Peer, index: number) => (
        <div key={peer?.peerId}>
          {peer?.userType === UserTypeEnum.AiWriter &&
          project?.projectUsers?.filter((x) => x.id === peer?.userId).length === 0 ? (
            <ProjectUserElement
              colorId={index + 1}
              name={peer.userName}
              userId={peer.userId}
              isUserActiveCallback={props.isUserActiveCallback}
              isUserLiveCallback={props.isUserLiveCallback}
              description={'Captioner'}
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default MainSectionProjectUsers;
